<ng-container *ngIf="!isPremium">
  <div class="ad-wrapper">
    <div
      class="ad-card glass-card"
      [class.ad-collapsed]="loading"
      [style.width.px]="currentWidth"
      [style.maxWidth]="'100%'"
    >
      <div class="ad-slot" #adContainer [class.hidden]="showPlaceholder" [style.minHeight.px]="currentHeight">
      </div>

      <div class="ad-slot" *ngIf="showPlaceholder" [style.minHeight.px]="currentHeight">
        <img *ngIf="placeholderSrc; else neutralPlaceholder" [src]="placeholderSrc" [alt]="placeholderAlt" loading="lazy" />
        <ng-template #neutralPlaceholder>
          <div class="placeholder-fallback"></div>
        </ng-template>
        <!-- <div class="glow"></div> -->
      </div>
    </div>
  </div>
</ng-container>
